import { useState } from 'react';
import { sendContactForm } from './callbacks/sendContactForm';
import { ContactUsForm } from './components/ContactUsForm';
import {
    ErrorMessage,
    MesssageIsSending,
    MesssageSent,
} from './components/SendMessages';
import { ContactUsFormData } from './types/ContactUsFormData';

export const ContactUsPage: React.FC = () => {
    const [isSending, setIsSending] = useState<boolean>(false);
    const [isAlreadySent, setIsAlreadySent] = useState<boolean>(false);
    const [hasError, setHasError] = useState<boolean>(false);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    const handleSubmit = (data: ContactUsFormData) => {
        if (data.purpose === undefined) {
            console.error('Try send message without selected purpose');
            return;
        }
        setIsSending(true);
        scrollToTop();
        sendContactForm(data)
            .then(() => setIsAlreadySent(true))
            .catch((error) => {
                console.error('During send contact form', error);
                setHasError(true);
            })
            .finally(() => setIsSending(false));
    };
    const showForm = !isSending && !isAlreadySent && !hasError;
    return (
        <div
            className="row align-items-center h-100 container"
            style={formContainerStyle}
        >
            <div data-testid="ContactUsPage" className="w-100">
                {showForm && <ContactUsForm onSubmit={handleSubmit} />}
                {hasError && <ErrorMessage />}
                {isSending && <MesssageIsSending />}
                {isAlreadySent && <MesssageSent />}
            </div>
        </div>
    );
};

const formContainerStyle: React.CSSProperties = {
    maxWidth: '600px',
    margin: '0 auto',
    marginBottom: '140px',
};
